var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMobileUserLoginBannerRtVector = function SvgMobileUserLoginBannerRtVector(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 80,
    viewBox: "0 0 142 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4651 15.8802C37.5855 23.8543 -0.785218 0.0948906 1.06433 -9H12.7855C16.0706 4.09485 59.8165 5.60617 97.1034 0.166395C134.39 -5.27338 142 11.9518 142 55.8195V80C142 80 129.955 52.5458 124.479 32.9035C119.458 14.8903 109.696 7.36856 72.4651 15.8802Z",
    fill: "#B7C6F3",
    stroke: "#B7C6F3",
    strokeWidth: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileUserLoginBannerRtVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MobileUserLoginBanner_RTVector.9bbd9cc4.svg";
export { ForwardRef as ReactComponent };